import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { AlertCircleIcon } from 'lucide-react';
export function PainSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="py-16 md:py-24 bg-[#faf6ee]" data-id="element-113">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-115">
          

          <div className="bg-white rounded-lg p-8 md:p-12 shadow-lg border-l-4 border-[#c9a961]" data-id="element-116">
            <div className="prose prose-lg max-w-none text-[#2d2d2d] leading-relaxed space-y-6" data-id="element-117">
              <p className="text-xl" data-id="element-118">
                A las mujeres les han enseñado que después de los 50 "es normal"
                subir de peso o vivir cansada. Pero no tiene por qué ser así. El
                cansancio crónico, la falta de enfoque y esa ropa que ya no te
                cierra son señales de inflamación celular.
              </p>

              <p className="text-xl font-semibold text-[#5d6e4f]" data-id="element-119">
                Si sigues intentando bajar de peso con cardio intenso o dietas
                restrictivas, solo estás elevando tu cortisol, lo que hace que
                tu cuerpo guarde más grasa en la cintura. Es hora de dejar de
                pelear contra tu biología y empezar a trabajar con ella.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}